export default __webpack_public_path__ + "static/media/man_with_laptop.47f49f6b.svg";